import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickOwnFreightPlantsState } from '@ordersnproducts/modules/one-click-order/selectors/one-click-ownFreight-plants.selector';

export class OneClickPreviewOwnFreightPlantsLoadingProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickOwnFreightPlantsState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
